import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { editUserSettings } from "actions/Users";
import SelectInput from "components/SelectInput";
import ButtonContained from "components/ButtonContained";

const UserSettingsSettingsModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const user = useSelector(state => state.users.userObject);
  const [localUser, setLocalUser] = useState(null);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (user) {
      setLocalUser(user);
    }
  }, [user]);

  useEffect(() => {
    if (localUser && user) {
      const isChanged = JSON.stringify(localUser) !== JSON.stringify(user);
      setHasChanges(isChanged);
    }
  }, [localUser]);

  const handleInputChange = (field, value) => {
    setLocalUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };

  const handleEditUserSettings = () => {
    dispatch(editUserSettings(
      localUser,
      {
        successMessage: intl.formatMessage({ id: "notifications.success.edit" })
      }
    ));
  }

  return (
    <div className="min-h-[300px] px-10 pt-4 flex flex-col justify-between gap-8">
      <div className="flex flex-col gap-4">
        <div>
          <h5 className="tw-heading-5 mb-4">{intl.formatMessage({ id: "pages.settings.Types" })}</h5>
        </div>
        <SelectInput
          id="User-Settings-Settings-Temperature-Input"
          dataCy="User-Settings-Settings-Temperature-Input"
          value={localUser?.temperatureScale || ""}
          placeholder={intl.formatMessage({ id: "comp.table.header.tempDisplay" })}
          onChange={(e) => handleInputChange("temperatureScale", e.target.value)}
          options={[
            {
              name: intl.formatMessage({ id: 'comp.table.header.tempC' }),
              value: 'celsius'
            },
            {
              name: intl.formatMessage({ id: 'comp.table.header.tempF' }),
              value: 'fahrenheit'
            }
          ]}
        />
        <SelectInput
          id="User-Settings-Settings-Date-Format-Input"
          dataCy="User-Settings-Settings-Date-Format-Input"
          value={localUser?.preferredDateFormat || ""}
          placeholder={intl.formatMessage({ id: "form.dateFormat" })}
          onChange={(e) => handleInputChange("preferredDateFormat", e.target.value)}
          options={[
            {
              name: intl.formatMessage({ id: 'pages.schedules.defaultShort' }),
              value: 'default'
            },
            {
              name: 'MM/DD/YYYY',
              value: 'MM/DD/YYYY'
            },
            {
              name: 'DD-MM-YYYY',
              value: 'DD-MM-YYYY'
            }
          ]}
        />
        <SelectInput
          id="User-Settings-Settings-Use-Site-Time-Input"
          dataCy="User-Settings-Settings-Use-Site-Time-Input"
          value={localUser?.useSiteTime ?? false}
          placeholder={intl.formatMessage({ id: "comp.button.use.siteTime" })}
          onChange={(e) => handleInputChange("useSiteTime", e.target.value === "true")}
          options={[
            {
              name: intl.formatMessage({ id: 'comp.form.yes' }),
              value: true
            },
            {
              name: intl.formatMessage({ id: 'comp.form.no' }),
              value: false
            }
          ]}
        />
        <SelectInput
          id="User-Settings-Settings-Preferred-Language-Input"
          dataCy="User-Settings-Settings-Preferred-Language-Input"
          value={localUser?.language || ""}
          placeholder={intl.formatMessage({ id: "comp.header.prefer.lang" })}
          onChange={(e) => handleInputChange("language", e.target.value)}
          options={[
            {
              name: intl.formatMessage({ id: 'languages.list.english' }),
              value: 'english'
            },
            {
              name: intl.formatMessage({ id: 'languages.list.spanish' }),
              value: 'spanish'
            },
            {
              name: intl.formatMessage({ id: 'languages.list.french' }),
              value: 'french'
            },
            {
              name: intl.formatMessage({ id: 'languages.list.german' }),
              value: 'german'
            },
            {
              name: intl.formatMessage({ id: 'languages.list.portuguese' }),
              value: 'portuguese'
            },
            {
              name: intl.formatMessage({ id: 'languages.list.swedish' }),
              value: 'swedish'
            }
          ]}
        />
      </div>
      <div>
        <ButtonContained
          id="User-Settings-Settings-Save-Changes-Button"
          dataCy="User-Settings-Settings-Save-Changes-Button"
          text={intl.formatMessage({ id: "comp.button.saveChanges" })}
          type="medium"
          disabled={!hasChanges}
          onClick={handleEditUserSettings}
        />
      </div>
    </div>
  );
}

export default UserSettingsSettingsModal;